import React from "react";
import { Link } from "react-router-dom";
import {
  Download,
  ArrowRight,
  ShieldCheck,
  FileText,
  Mail,
  Scale,
  FileCheck,
  Factory,
} from "lucide-react";

const regulations = [
  {
    type: "resolucion",
    title: "Resolución 909 de 2008",
    entity:
      "Establece normas y estándares de emisión admisibles de contaminantes a la atmósfera para fuentes fijas.",
  },
  {
    type: "resolucion",
    title: "Resolución 935 de 2011",
    entity:
      "Establece los métodos para la medición de emisiones por fuentes fijas, modificada o complementada por el IDEAM.",
  },
  {
    type: "resolucion",
    title: "Resolución 760 de 2010",
    entity:
      "Adopta el Protocolo para el Control y Vigilancia de la Contaminación Atmosférica Generada por Fuentes Fijas.",
  },
];

const getIcon = () => <FileCheck size={18} stroke="#ee7d32" strokeWidth={2} />;

const FixedSourcesService = () => {
  return (
    <>
      {/* FUENTES FIJAS */}
      <section className="py-16 md:py-20 bg-white  overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="flex items-center gap-3">
                <div>
                  <span className="text-[#ee7d32] text-xs sm:text-sm font-bold uppercase tracking-[0.2em]">
                    Servicios de Monitoreo
                  </span>

                  <div className="mt-2 w-16 h-[2px] bg-[#ee7d32]/40 rounded-full" />
                </div>
              </div>

              <h2 className="mt-5 text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
                Fuentes Fijas
              </h2>

              <div className="mt-6 md:mt-8 space-y-5 md:space-y-7">
                <p className="text-[#374151] text-base md:text-lg leading-7 md:leading-8">
                  Grupo Sierra Alta S.A.S. comprende la importancia de
                  monitorear y controlar las emisiones provenientes de fuentes
                  fijas como parte fundamental de la gestión ambiental y el
                  cumplimiento normativo. Mediante la implementación de técnicas
                  y equipos especializados, se realiza la medición precisa de
                  contaminantes atmosféricos generados por procesos industriales
                  y productivos, proporcionando datos confiables para evaluar el
                  impacto ambiental y garantizar que los niveles de emisión se
                  mantengan dentro de los límites establecidos por la
                  legislación vigente. Esta información es clave para diseñar
                  estrategias efectivas de mitigación, optimizar procesos y
                  minimizar riesgos ambientales y legales.
                </p>
              </div>

              <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4">
                <a
                  href="/Docs/Resolucion_No._0723_del_16_de_junio_de_2027.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center gap-3 bg-[#ee7d32] hover:bg-[#d96d24] text-white px-7 py-4 rounded-lg font-semibold shadow-lg shadow-[#ee7d32]/25 transition-all duration-300 hover:-translate-y-1"
                >
                  <ShieldCheck className="w-5 h-5" color="#ffffff" />

                  <span className="text-white">Ver acreditación</span>

                  <ArrowRight
                    className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
                    color="#ffffff"
                  />
                </a>

                <a
                  href="/Docs/PORTAFOLIO SIERRA ALTA LAA 2026.pdf"
                  download
                  className="group inline-flex items-center justify-center gap-3 border border-[#ee7d32] bg-[#ee7d32]/10 hover:bg-[#ee7d32] px-7 py-4 rounded-lg font-semibold transition-all duration-300 hover:-translate-y-1"
                >
                  <FileText className="w-5 h-5 stroke-[#ee7d32] group-hover:stroke-white transition-colors duration-300" />

                  <span className="text-[#ee7d32] group-hover:text-white transition-colors duration-300">
                    Descargar brochure
                  </span>

                  <Download className="w-5 h-5 stroke-[#ee7d32] group-hover:stroke-white transition-all duration-300 group-hover:translate-y-[2px]" />
                </a>
              </div>
            </div>

            <div className="relative order-1 lg:order-2">
              <div className="absolute -inset-3 md:-inset-4 bg-[#ee7d32]/10 blur-3xl rounded-[50px]" />

              <div className="absolute -top-4 -right-4 w-32 h-32 border border-[#ee7d32]/30 rounded-full" />
              <div className="relative overflow-hidden shadow-2xl group rounded-tl-[90px] rounded-br-[90px] rounded-tr-[28px] rounded-bl-[28px]">
                <img
                  src="/Images/services/enviromental/monitoring/fixed-sources-service/fuentes-fijas.webp"
                  alt="Fuentes fijas"
                  className="w-full h-[340px] sm:h-[450px] md:h-[520px] object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />

                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto">
                  <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-4 sm:px-5 shadow-xl">
                    <div className="flex items-center gap-3">
                      <div className="w-11 h-11 rounded-xl bg-[#ee7d32] flex items-center justify-center shrink-0">
                        <Factory className="w-5 h-5" color="white" />
                      </div>

                      <div>
                        <p className="text-white/80 text-xs sm:text-sm">
                          Servicio especializado
                        </p>

                        <h4 className="text-white font-semibold text-sm sm:text-base">
                          Fuentes Fijas
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute top-0 right-0 w-28 h-28 bg-[#ee7d32]/20 blur-2xl" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NORMATIVIDAD */}
      <section className="py-10 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-[30px] border border-[#ececec] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
            <div className="absolute top-0 right-0 w-[280px] h-[280px] bg-[#ee7d32]/5 rounded-full blur-3xl" />

            <div className="relative px-6 md:px-8 pt-7 pb-5 border-b border-[#f3f4f6]">
              <div className="flex items-start gap-4">
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 bg-[#ee7d32]/15 blur-xl opacity-60" />

                  <div className="relative w-12 h-12 rounded-2xl bg-gradient-to-br from-[#fff7f2] to-[#ffe8d9] border border-[#ffd7bf] flex items-center justify-center">
                    <Scale size={22} stroke="#ee7d32" strokeWidth={2} />
                  </div>
                </div>

                <div className="flex-1">
                  <span className="inline-flex items-center rounded-full border border-[#ffd7bf] bg-[#fff4ec] px-3 py-1 text-[11px] font-semibold tracking-wide text-[#ee7d32]">
                    MARCO REGULATORIO
                  </span>

                  <h2 className="mt-2 text-2xl md:text-[30px] font-bold tracking-tight leading-tight text-[#111827]">
                    Normatividad aplicable para fuentes fijas
                  </h2>

                  <p className="mt-2 max-w-3xl text-sm md:text-[15px] leading-6 text-[#6b7280]">
                    Normativa ambiental vigente aplicable al monitoreo,
                    evaluación, control y gestión de emisiones atmosféricas
                    generadas por fuentes fijas.
                  </p>
                </div>
              </div>
            </div>

            <div className="px-6 md:px-8 pt-5 pb-7">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {regulations.map((item, index) => (
                  <div
                    key={index}
                    className="
                group relative overflow-hidden
                rounded-2xl
                border border-[#ededed]
                bg-gradient-to-b from-white to-[#fcfcfc]
                p-4
                transition-all duration-300
                hover:-translate-y-1
                hover:border-[#ffd7bf]
                hover:shadow-[0_10px_24px_rgba(238,125,50,0.08)]
              "
                  >
                    <div className="absolute inset-0 opacity-0 transition duration-500 group-hover:opacity-100 bg-gradient-to-r from-[#fff3eb] to-transparent" />

                    <div className="relative flex items-start gap-3.5">
                      <div className="w-10 h-10 rounded-xl bg-[#fff5ef] border border-[#ffe1cf] flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-105">
                        {getIcon(item.type)}
                      </div>

                      <div className="min-w-0">
                        <h3 className="text-[15px] font-semibold leading-5 text-[#111827]">
                          {item.title}
                        </h3>

                        <p className="mt-1.5 text-sm leading-5 text-[#6b7280]">
                          Expedido por {item.entity}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA MONITOREO */}
      <section className="relative py-14 md:py-20 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="group relative overflow-hidden rounded-[28px] md:rounded-[30px] border border-[#ececec] bg-white shadow-[0_10px_35px_rgba(0,0,0,0.04)] transition-all duration-300 hover:shadow-[0_18px_50px_rgba(0,0,0,0.08)]">
            <div className="absolute top-0 left-0 h-full w-1.5 bg-gradient-to-b from-[#ee7d32] via-orange-400 to-[#ee7d32]" />

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 px-5 py-7 sm:px-6 md:px-8 md:py-8 lg:px-10 lg:py-10">
              <div className="flex flex-col sm:flex-row items-start gap-5 max-w-3xl">
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 bg-[#ee7d32]/20 blur-xl rounded-2xl" />

                  <div className="relative w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center">
                    <Mail
                      size={34}
                      className="md:w-[42px] md:h-[42px] stroke-[#ee7d32] transition-colors duration-300"
                    />
                  </div>
                </div>

                <div className="min-w-0">
                  <span className="inline-flex items-center rounded-full bg-[#ee7d32]/10 border border-[#ee7d32]/20 px-3 py-1 text-[11px] md:text-[12px] font-semibold uppercase tracking-wider text-[#ee7d32]">
                    Asesoría técnica especializada
                  </span>

                  <h3 className="mt-3 text-xl sm:text-2xl md:text-3xl font-bold tracking-tight text-[#111827] leading-tight">
                    ¿Necesitas monitoreo ambiental confiable para tu proyecto?
                  </h3>

                  <p className="mt-3 text-sm md:text-base leading-6 md:leading-7 text-[#6b7280] max-w-2xl">
                    Recibe acompañamiento técnico especializado en monitoreo,
                    control y gestión ambiental con soluciones adaptadas a las
                    necesidades de tu operación.
                  </p>
                </div>
              </div>

              <div className="flex w-full lg:w-auto">
                <Link
                  to="/contact-us?division=ambiental&service=Monitoreo ambiental"
                  className="group/btn inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-lg bg-[#ee7d32] px-6 py-3.5 md:px-7 md:py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#e56f20] hover:shadow-lg hover:shadow-[#ee7d32]/20"
                >
                  Contáctanos
                  <ArrowRight
                    size={18}
                    className="transition-transform duration-300 group-hover/btn:translate-x-1"
                    color="white"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FixedSourcesService;
